import { ProductCategory } from "@utils/constants";
import { usePdpProductData } from "./usePdpProductData";
import { usePdpJewelryData } from "./usePdpJewelryData";
import { Diamond } from "@src/types/DiamondDetail";

interface UsePdpDataProps {
  route: any;
  isFocused: boolean;
  isModal: boolean;
  product_type: ProductCategory;
  priceMode: number;
  priceMarkup: number;
  userInfo: any;
  mGroupIds: any;
  isCustomApp: boolean;
  additionalAttributes?: any;
  componentData?: any;
  isVariationRequired: boolean;
  findMatchSectionLayout: any;
  shouldShowJewelryComponents: (itemDetail: any) => boolean;
  enableJewelryBuilder: boolean;
  enterSecondFlow: boolean;
  mItem: any;
  mStoneItemDetail: any;
  matchingPairItemDetail: any;
  setItemDetail: (item: Diamond) => void;
  setStoneItemDetail: (item: any) => void;
  setMatchingPairItemDetail: (item: any) => void;
  appendNewVariation: (variations: any[]) => void;
  setAllTypes: (item: any) => void;
  setIsVariationRequired: (required: boolean) => void;
  setDefaultSlug: (slug: any) => void;
  setUserSelectedSlug: (slug: any) => void;
  setCustomDesignConfiguration: (config: boolean) => void;
  updateJcSelectedOptions: (item: any) => void;
  jcSelectedOption: any;
  setPersonalization: (personalization: any) => void;
  renderShowErrorComponent: () => void;
  showLabGrownPopUp: () => void;
  fromReviewPage: boolean;
  resetDynamicParams: () => void;
  applyFetchedItemPrice?: (source?: Diamond) => void;
}

export const usePdpData = ({
  route,
  isFocused,
  isModal,
  product_type,
  priceMode,
  priceMarkup,
  userInfo,
  mGroupIds,
  isCustomApp,
  additionalAttributes,
  componentData,
  isVariationRequired,
  findMatchSectionLayout,
  shouldShowJewelryComponents,
  enableJewelryBuilder,
  enterSecondFlow,
  mItem,
  mStoneItemDetail,
  matchingPairItemDetail,
  setItemDetail,
  setStoneItemDetail,
  setMatchingPairItemDetail,
  appendNewVariation,
  setAllTypes,
  setIsVariationRequired,
  setDefaultSlug,
  setUserSelectedSlug,
  setCustomDesignConfiguration,
  updateJcSelectedOptions,
  jcSelectedOption,
  setPersonalization,
  renderShowErrorComponent,
  showLabGrownPopUp,
  fromReviewPage,
  resetDynamicParams,
  applyFetchedItemPrice,
}: UsePdpDataProps) => {
  // Use product data hook for core product fetching and processing
  const {
    getDiamondDetailData,
    getMatchPairDetailData,
    productId,
    itemDetail,
    initialItemDetail,
    localComponentDetail,
    setLocalComponentDetail,
    reportBadMedia,
    removeBreadCrumbFromHistory,
  } = usePdpProductData({
    route,
    isFocused,
    isModal,
    product_type,
    priceMode,
    priceMarkup,
    userInfo,
    mGroupIds,
    isCustomApp,
    additionalAttributes,
    componentData,
    findMatchSectionLayout,
    mItem,
    mStoneItemDetail,
    matchingPairItemDetail,
    setItemDetail,
    setStoneItemDetail,
    setMatchingPairItemDetail,
    setIsVariationRequired,
    setDefaultSlug,
    setPersonalization,
    jcSelectedOption,
    appendNewVariation,
    setAllTypes,
    renderShowErrorComponent,
    showLabGrownPopUp,
    fromReviewPage,
    enterSecondFlow,
    resetDynamicParams,
    applyFetchedItemPrice,
  });

  // Use jewelry data hook for jewelry-specific fetching and processing
  const {
    jewelryVariationData,
    variationSuccess,
    variationIsFetching,
    variationIsFetched,
    componentsData,
    componentsLoading,
    componentsFetching,
    getAddToJewelryOptionsData,
  } = usePdpJewelryData({
    route,
    isFocused,
    isModal,
    product_type,
    priceMode,
    userInfo,
    isVariationRequired,
    shouldShowJewelryComponents,
    enableJewelryBuilder,
    enterSecondFlow,
    initialItemDetail,
    itemDetail,
    getDiamondDetailData,
    additionalAttributes,
    setUserSelectedSlug,
    setCustomDesignConfiguration,
    updateJcSelectedOptions,
    appendNewVariation,
    setAllTypes,
    setMatchingPairItemDetail,
  });

  return {
    getDiamondDetailData,
    getMatchPairDetailData,
    jewelryVariationData,
    variationSuccess,
    variationIsFetching,
    variationIsFetched,
    componentsData,
    componentsLoading,
    componentsFetching,
    getAddToJewelryOptionsData,
    itemDetail,
    productId,
    localComponentDetail,
    setLocalComponentDetail,
    reportBadMedia,
    removeBreadCrumbFromHistory,
  };
};
